import type { FeatureGroup } from '../../../types';
import { ADMINISTRATIVE_FEATURE_GROUP } from '../group';

export const PRODUCTS_FEATURE_GROUP: FeatureGroup = {
  guid: 'e1b4ca45-7d3f-4e90-a123-8f0e1d2bff00',
  name: 'products',
  description: 'Products features — view the products dashboard',
  product: 'account',
  parentGuid: ADMINISTRATIVE_FEATURE_GROUP.guid,
};
